// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportModalFilter_root__3SEbL","footer":"ReportModalFilter_footer__2XELS"};